import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { UserComponent } from './user.component';
import { UserFormComponent } from './shared/user-form/user-form.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { FormsService } from '../shared/forms.service';
import { UserService } from './shared/user.service';
import { AdminFormComponent } from './admin/shared/admin-form/admin-form.component';
import { CustomerFormComponent } from './customer/shared/customer-form/customer-form.component';
import { SchoolFormComponent } from './school/shared/school-form/school-form.component';
import { ConsigneeFormComponent } from './consignee/shared/consignee-form/consignee-form.component';
import { UserFormService } from './shared/user-form.service';
import { UserCreateComponent } from './user-create/user-create.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  providers: [
    UserService,
    FormsService,
    UserFormService
  ],
  declarations: [
    UserComponent,
    UserFormComponent,
    UserEditComponent,
    AdminFormComponent,
    CustomerFormComponent,
    SchoolFormComponent,
    ConsigneeFormComponent,
    UserCreateComponent
  ]
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/user/user.module.ts